export default {
    path: '/vendors',
    name: 'Vendors',
    component: () => import('@/layout/index.vue'),
    // redirect: {
    //     name: "EquipmentMasterData"
    // },
    meta: {
        title: '供应商',
        icon: 'iconfont icon-chaxunbaobiao',
        role: 'BACK_MENU9'
    },
    children: [{
            path: '/labelAttr',
            name: 'labelAttr',
            component: () => import('@/views/vendors/labelAttr.vue'),
            meta: {
                title: '标签属性',
                role: 'BACK_MENU9_M1'
            }
        },

        {
            path: '/materialType',
            name: 'materialType',
            component: () => import('@/views/vendors/materialType.vue'),
            meta: {
                title: '物料类型',
                role: 'BACK_MENU9_M2'
            }
        },
        {
            path: '/labelMat',
            name: 'labelMat',
            component: () => import('@/views/vendors/labelMat.vue'),
            meta: {
                title: '物料类型标签',
                role: 'BACK_MENU9_M3'
            }
        },
        {
            path: '/vendorLabel',
            name: 'vendorLabel',
            component: () => import('@/views/vendors/vendorLabel.vue'),
            meta: {
                title: '供应商物料',
                role: 'BACK_MENU9_M4'
            }
        },
        {
            path: '/boxBarcodePrint',
            name: 'BoxBarcodePrint',
            component: () => import('@/views/vendors/boxBarcodePrint.vue'),
            meta: {
                title: '箱标签打印',
                role: 'BACK_MENU9_M5'
            }
        },

    ],
}